import { Injectable } from "@angular/core";
import { DataStore } from "../shared/models/DataStore";

@Injectable()
export class OrganisationStore extends DataStore {
    constructor() {
        super();
    }

    public initializeStore() {
        this.set('organisation', null);
    }
}